<template>
  <a-modal
    :title="title"
    :width="870"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入标题" />
        </a-form-model-item>
        <a-form-model-item label="方案分类" prop="sort">
          <j-dict-select-tag
            v-model="form.sort"
            placeholder="请选择方案分类"
            dictCode="group_counseling_sort"
          />
        </a-form-model-item>
        <a-form-model-item label="详细介绍" prop="evalWay">
          <WangEditor
            v-model="form.content"
            :editorStyle="{ minHeight: '300px' }"
            style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import WangEditor from '@/components/WangEditor'
import { postAction, putAction } from '@api/manage'

export default {
  name: 'CreateEvaluation',
  components: {
    WangEditor,
  },
  props: {
    title: {
      type: String,
      default: '创建',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        sort: [{ required: true, message: '请选择方案分类', trigger: 'blur' }],
        // radius: [{ required: true, message: '请选择测评范围', trigger: 'blur' }],
        // evalWay: [{ required: true, message: '请选择测评方式', trigger: 'blur' }],
      },
      currEditRecord: null,
    }
  },
  methods: {
    showModal(data) {
      if (data) {
        this.currEditRecord = data
        this.form = { title: data.title, sort: data.sort, content: data.content }
      }
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.form = {}
    },
    async handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const res = this.currEditRecord
          ? await putAction('/resourceGroupCounseling/edit', {
              ...this.form,
              id: this.currEditRecord.id,
            })
          : await postAction('/resourceGroupCounseling/add', this.form)
        if (res.success) {
          console.log('操作成功：', res.message)
          this.$message.success(res.message)
          this.$emit('refreshData', res)
          return
        }
        this.$message.error(res.message)
      })
      this.hideModal()
    },
    handleCancel() {
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less"></style>
